import { LatamContactPage } from '@/screens/Latam/Contact/LatamContactPage';

export default function ContactPage() {
  return <LatamContactPage locale="pt-BR" />;
}
